<template>
  <modal v-if="active" width="580px" :title="modalTitle" @close="close">
    <template #default>
      <div class="text-center">
        <ui-icon size="64" :color="tachometerColor" :icon="`far ${tachometerIcon}`"></ui-icon>
        <div class="text text-left" v-html="text"></div>
      </div>
    </template>

    <template #footer>
      <section class="justify-end xs12" style="display: flex">
        <ui-button :text="t('Not Now')" @click="close" icon="fas fa-times" />
        <ui-button
          :text="t('View Plans')"
          icon="fas fa-check"
          button-style="accent"
          @click="goToSubscription"
        />
      </section>
    </template>
  </modal>
</template>

<script setup lang="ts">
import { useEventsLimitNotice } from '@/components/app-exceptions-resolver/dialogs/useEventsLimitNotice';

const { t, active, tachometerIcon, tachometerColor, modalTitle, text, close, goToSubscription } =
  useEventsLimitNotice();
</script>

<style lang="scss" scoped>
.text {
  font-size: 15px;
  margin-top: 20px;

  :deep(button) {
    color: var(--color-blue) !important;
    text-decoration: underline !important;
  }
}
</style>
